import WebFont from 'webfontloader';
import { WEBFONT_CONFIG } from 'config/constants';

WebFont.load(WEBFONT_CONFIG);
